import React from "react";
import { Route, Navigate } from "react-router-dom";
import { isAuthenticated } from "../services/account.service";
import Loader from "../common/loader";
import NotFoundPage from "../components/errors/404";
import { ROLES } from "../constants/general.constant";
import BankerProfile from "../components/banker/profile/bankerProfile";
import MainLayout from "../layout/mainLayout";
import BankerDeals from "../components/banker/deals";
import BankerDealDetails from "../components/banker/deals/BankerDealDetails";
import BidDetailsPage from "../components/banker/bidDetails";
import BankerRegister from "../components/banker/register";
import {useAuth} from "../hook/userRoleHook";
import Notifications from "../components/customers/notifications";

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { role, loading, redirectionUrl, isLoginPage } = useAuth();

  if (!isAuthenticated() && !isLoginPage) {
    return <Navigate to={redirectionUrl} replace />;
  }

  if (loading) return <Loader />;

  if (role !== ROLES.BANKER) return <NotFoundPage />;

  return <>{children}</>;
};

const WithLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ProtectedRoute>
    <MainLayout>{children}</MainLayout>
  </ProtectedRoute>
);

const WithoutLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ProtectedRoute>{children}</ProtectedRoute>
);

const bankerRoutesConfig = [
  { key: "banker-profile", path: "/banker/profile", element: <BankerProfile />, layout: "with" },
  { key: "banker-register", path: "/banker/register", element: <BankerRegister />, layout: "with" },
  { key: "banker-loan-status", path: "/banker/loan-status", element: <BankerDeals />, layout: "with" },
  { key: "banker-notifications", path: "/banker/notifications", element: <Notifications />, layout: "with" },
  { key: "banker-deal-details", path: "/banker/deals/:id", element: <BankerDealDetails />},
  { key: "banker-bid-details", path: "/banker/bid-details", element: <BidDetailsPage />, layout: "with" },
];

const BankerRoutes = bankerRoutesConfig.map(({ key, path, element, layout }) => (
  <Route
    key={key}
    path={path}
    element={layout === "with" ? <WithLayout>{element}</WithLayout> : <WithoutLayout>{element}</WithoutLayout>}
  />
));

export default BankerRoutes;
